<template>
  <div class="pagination-bar">
    <div class="pagination-controls">
      <a-pagination
        :key="renderCount"
        :current="currentPage"
        :defaultCurrent="defaultValue"
        :defaultPageSize="defaultPageSize"
        :hideOnSinglePage="hideOnSinglePage"
        :pageSize="currentPageSize"
        :pageSizeOptions="pageSizeOptions"
        :showQuickJumper="showQuickJumper"
        :showSizeChanger="showSizeChanger"
        :simple="simple"
        :size="size"
        :total="total"
        @change="handlePageChange"
        @showSizeChange="handlePageSizeChange"
      >
        <template slot="buildOptionText" slot-scope="props">
          <slot :value="props.value" />
        </template>
      </a-pagination>
      <small class="pagination-total"> {{ $t('items_per_page') }} </small>
    </div>
    <div class="pagination-total" v-if="showTotal">
      {{ showTotal(total, totalRange) }}
    </div>
  </div>
</template>

<script>
import Pagination from 'ant-design-vue/es/pagination'
import 'ant-design-vue/es/pagination/style'

export default {
  name: 'MPagination',
  components: { APagination: Pagination },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      renderCount: 1,
    }
  },
  props: {
    value: {
      type: Number,
    },
    defaultValue: {
      type: Number,
      default: 1,
    },
    defaultPageSize: {
      type: Number,
      default: 10,
    },
    hideOnSinglePage: {
      type: Boolean,
      default: true,
    },
    pageSize: {
      type: Number,
    },
    pageSizeOptions: {
      type: Array,
      default: () => ['10', '25', '50'],
    },
    showQuickJumper: {
      type: Boolean,
    },
    showSizeChanger: {
      type: Boolean,
      default: true,
    },
    simple: {
      type: Boolean,
    },
    size: {
      type: String,
    },
    total: {
      type: Number,
      default: 0,
    },
    showTotal: {
      type: Function,
    },
  },
  computed: {
    totalRange() {
      const start = (this.currentPage - 1) * this.currentPageSize + 1
      const end = Math.min(this.currentPage * this.currentPageSize, this.total)
      return this.total === 0 ? [0, 0] : [start, end]
    },
    currentPage() {
      return this.value || this.defaultValue
    },
    currentPageSize() {
      return this.pageSize || this.defaultPageSize
    },
    isOptionSelectionOpen() {
      return document.querySelectorAll('.ant-pagination-options')
    },
  },
  mounted() {
    let combobox = document.querySelectorAll('[role="combobox"]')
    combobox.forEach((el) => {
      el.setAttribute('aria-label', 'page size')
    })
  },
  methods: {
    handlePageChange(page, pageSize) {
      this.$emit('change', page, pageSize)
    },
    handlePageSizeChange(current, pageSize) {
      this.$emit('update:page-size', pageSize)
      this.renderCount++
    },
  },
}
</script>
<style lang="less">
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.pagination-controls {
  display: flex;
  align-items: center;
}
.pagination-total {
  margin-left: 16px;
  white-space: nowrap;
  color: var(--neutral-light);
}
</style>
